export default __webpack_public_path__ + "static/media/photo_5282747746622312907_y.2e80392c.jpg";